import { useEffect, useState } from 'react';
import { convertNumberToLocaleString } from '../../../utils/commonFunctions';
import BookingDetailsTableRow from './BookingDetailsTableRow';

interface IBookingDetailsTable {
  selectedTimeSlotCount: number;
  creditsPerAppointment: number;
  slotDuration: number;
  appointmentBufferTime: number;
}

const BookingDetailsTable = ({
  selectedTimeSlotCount,
  creditsPerAppointment,
  slotDuration,
  appointmentBufferTime,
}: IBookingDetailsTable) => {
  // integration of react hooks here
  const [selectedExtraSlots, setSelectedExtraSlot] = useState<number>(0);

  useEffect(() => {
    if (selectedTimeSlotCount > 1) {
      setSelectedExtraSlot(selectedTimeSlotCount - 1);
    } else {
      setSelectedExtraSlot(0);
    }
  }, [selectedTimeSlotCount]);

  // rendering booking details table component here
  return (
    <div className='w-full space-y-2 text-sm border-2 border-dashed border-base-cyan rounded-lg p-2'>
      <div className='grid grid-cols-booking-details-table text-center border-b-2 border-base-cyan/55 font-semibold text-legal-dark-blue'>
        <p className='font-semibold text-base-cyan text-left'>
          Booking Details Table
        </p>
        <p>Credits</p>
        <p>Minutes</p>
      </div>

      <div className='space-y-3'>
        <BookingDetailsTableRow>
          <p>Per Slot</p>
          <p>{creditsPerAppointment}</p>
          <p>{slotDuration}</p>
        </BookingDetailsTableRow>

        <BookingDetailsTableRow>
          <p>Selected Slots</p>
          <p></p>
          <p>X {selectedTimeSlotCount}</p>
        </BookingDetailsTableRow>

        <div className='border-b-2 border-dashed border-base-cyan/55' />

        <BookingDetailsTableRow isTotal>
          <p>Sub Total</p>
          <p>
            {convertNumberToLocaleString(
              creditsPerAppointment * selectedTimeSlotCount
            )}
          </p>
          <p>{slotDuration * selectedTimeSlotCount}</p>
        </BookingDetailsTableRow>

        {selectedExtraSlots ? (
          <>
            <div className='border-b-2 border-dashed border-base-cyan/55' />

            <BookingDetailsTableRow>
              <p>Extra Per Additional Slot</p>
              <p>
                {convertNumberToLocaleString(
                  (creditsPerAppointment / slotDuration) * appointmentBufferTime
                )}
              </p>
              <p>{appointmentBufferTime}</p>
            </BookingDetailsTableRow>

            <BookingDetailsTableRow>
              <p>Selected Extra Slots</p>
              <p></p>
              <p>X {selectedExtraSlots}</p>
            </BookingDetailsTableRow>

            <div className='border-b-2 border-dashed border-base-cyan/55' />

            <BookingDetailsTableRow isTotal>
              <p>Total Extra</p>
              <p>
                {convertNumberToLocaleString(
                  (creditsPerAppointment / slotDuration) *
                    appointmentBufferTime *
                    selectedExtraSlots
                )}
              </p>
              <p>{appointmentBufferTime * selectedExtraSlots}</p>
            </BookingDetailsTableRow>
          </>
        ) : null}

        <div className='border-b-2 border-dashed border-base-cyan/55' />

        <BookingDetailsTableRow isGrandTotal>
          <p>Grand Total</p>
          <p>
            {convertNumberToLocaleString(
              creditsPerAppointment * selectedTimeSlotCount +
                (creditsPerAppointment / slotDuration) *
                  appointmentBufferTime *
                  selectedExtraSlots
            )}
          </p>
          <p>
            {slotDuration * selectedTimeSlotCount +
              appointmentBufferTime * selectedExtraSlots}
          </p>
        </BookingDetailsTableRow>
      </div>
    </div>
  );
};

export default BookingDetailsTable;
